
        import {store, MERGED_BUNDLES_NAME} from 'bundleStore';
        
        let bundle;
        
        if ('ScalableInputControlsBundle' !== MERGED_BUNDLES_NAME) {
            store['ScalableInputControlsBundle'] = store['ScalableInputControlsBundle'] || {};
            bundle = store['ScalableInputControlsBundle'];
        } else {
            bundle = Object.keys(store).reduce((acc, key) => {
                return {
                    ...acc,
                    ...store[key]
                }
            }, {});
        }
                                     
        export default bundle;
    